import { render, staticRenderFns } from "./TemplateZone.html?vue&type=template&id=d0fe7aca&"
import script from "./TemplateZone.vue?vue&type=script&lang=js&"
export * from "./TemplateZone.vue?vue&type=script&lang=js&"
import style0 from "./TemplateZone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VBtn,VCardText,VNavigationDrawer})
